import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import dayjs from "dayjs";
import { fetchImageAsBase64 } from "../../../../../../../utils/imageUtils";

//APP
import { imgLogo } from "../../../../../../../utils/base64-Imgs";
import { typeEstruturaCompraInsumos, typeInsumos } from "./index";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

export interface HeaderDef {
    logo: string;
    titulo: string;
    nome_arquivo?: string;
    razaoSocial: string;
    cliente?: string;
    safra?: string;
    cultura?: string;
    autor?: string;
}

export const gerarDocDefinition = (
    dados: (typeEstruturaCompraInsumos | typeInsumos)[],
    headerInfo?: HeaderDef
) => {
    const content: any[] = [];

    // Header Principal (Somente Primeira Página)
    content.push({
        stack: [
            {
                image: headerInfo?.logo || 'imgLogoAlias',
                width: 80,
                alignment: 'center',
                margin: [0, 0, 0, 10]
            },
            {
                text: `${headerInfo?.titulo}`,
                style: 'headerMain',
                alignment: 'center',
                margin: [0, 0, 0, 10]
            },
            {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 760,
                        h: 4,
                        linearGradient: ['#e5f1e1', '#5da57d', '#0e743f']
                    }
                ],
            },
            {
                stack: [
                    {
                        text: `${headerInfo?.razaoSocial}`,
                        fontSize: 8,
                        bold: true,
                        color: '#4D4D4D',
                        alignment: 'center'
                    },
                    ...(headerInfo?.cliente ? [{
                        margin: [0, 10, 0, 0],
                        table: {
                            widths: ['*', '30%', '30%'],
                            body: [
                                [
                                    {
                                        text: [
                                            { text: 'CLIENTE\n', fontSize: 8, color: '#7b7b7b', bold: true },
                                            { text: (headerInfo.cliente || '-').toUpperCase(), fontSize: 11, bold: true, color: '#000000' }
                                        ],
                                        alignment: 'center',
                                        margin: [5, 5, 5, 5]
                                    },
                                    {
                                        text: [
                                            { text: 'SAFRA\n', fontSize: 8, color: '#7b7b7b', bold: true },
                                            { text: (headerInfo.safra || '-').toUpperCase(), fontSize: 11, bold: true, color: '#000000' }
                                        ],
                                        alignment: 'center',
                                        margin: [5, 5, 5, 5]
                                    },
                                    {
                                        text: [
                                            { text: 'CULTURA\n', fontSize: 8, color: '#7b7b7b', bold: true },
                                            { text: (headerInfo.cultura || '-').toUpperCase(), fontSize: 11, bold: true, color: '#000000' }
                                        ],
                                        alignment: 'center',
                                        margin: [5, 5, 5, 5]
                                    }
                                ]
                            ]
                        },
                        layout: {
                            hLineWidth: () => 1,
                            vLineWidth: () => 1,
                            hLineColor: () => '#7b7b7b',
                            vLineColor: () => '#7b7b7b'
                        }
                    }] : [])
                ],
                margin: [0, 5, 0, 20]
            }
        ],
        margin: [0, 0, 0, 10]
    });

    const isJuntarInsumos = dados.length > 0 && !('insumos' in dados[0]);

    if (isJuntarInsumos) {
        let globalInsumoIndex = 0; // Para controle de zebra
        const corHeader = '#0e743f';
        const bodyInsumos: any[] = [
            // Table Header Insumos
            [
                { text: 'Insumo', style: 'tableHeader', alignment: 'left', fillColor: corHeader, color: 'white' },
                { text: 'Quantidade', style: 'tableHeader', alignment: 'left', fillColor: corHeader, color: 'white' }
            ]
        ];

        (dados as typeInsumos[]).forEach((insu) => {
            const zebraColor = (globalInsumoIndex % 2 === 0) ? null : '#e5f1e1';

            bodyInsumos.push([
                { text: insu.insumo_nome || '-', margin: [2, 4, 2, 4], alignment: 'left', fillColor: zebraColor },
                { text: insu.quantidade_total_view || '-', margin: [2, 4, 2, 4], alignment: 'left', fillColor: zebraColor },
            ]);

            globalInsumoIndex++;
        });

        if (dados.length === 0) {
            bodyInsumos.push([
                { text: 'Nenhum insumo planejado.', colSpan: 2, margin: [2, 4, 2, 4], alignment: 'center', italics: true, fillColor: null },
                {}
            ]);
        }

        content.push({
            table: {
                widths: ['70%', '30%'],
                body: bodyInsumos
            },
            layout: {
                fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                    if (rowIndex === 0) return '#a6a6a6'; // Header principal
                    return null;
                }
            },
            margin: [0, 0, 0, 15]
        });
    } else {
        (dados as typeEstruturaCompraInsumos[]).forEach((propriedade) => {
            // Header Propriedade
            content.push({
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                text: propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA",
                                style: 'headerPropriedade',
                                alignment: 'center',
                                fillColor: '#5da57d',
                                color: 'white',
                                bold: true,
                                margin: [0, 5, 0, 5]
                            }
                        ]
                    ]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 10]
            });

            let globalInsumoIndex = 0; // Para controle de zebra
            const corHeader = '#0e743f';
            const bodyInsumos: any[] = [
                // Table Header Insumos
                [
                    { text: 'Insumo', style: 'tableHeader', alignment: 'left', fillColor: corHeader, color: 'white' },
                    { text: 'Quantidade', style: 'tableHeader', alignment: 'left', fillColor: corHeader, color: 'white' }
                ]
            ];

            propriedade.insumos.forEach((insu) => {
                const zebraColor = (globalInsumoIndex % 2 === 0) ? null : '#e5f1e1';

                bodyInsumos.push([
                    { text: insu.insumo_nome || '-', margin: [2, 4, 2, 4], alignment: 'left', fillColor: zebraColor },
                    { text: insu.quantidade_total_view || '-', margin: [2, 4, 2, 4], alignment: 'left', fillColor: zebraColor },
                ]);

                globalInsumoIndex++;
            });

            if (propriedade.insumos.length === 0) {
                bodyInsumos.push([
                    { text: 'Nenhum insumo planejado para esta propriedade.', colSpan: 2, margin: [2, 4, 2, 4], alignment: 'center', italics: true, fillColor: null },
                    {}
                ]);
            }

            content.push({
                table: {
                    widths: ['70%', '30%'],
                    body: bodyInsumos
                },
                layout: {
                    fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                        if (rowIndex === 0) return '#a6a6a6'; // Header principal
                        return null;
                    }
                },
                margin: [0, 0, 0, 15]
            });
        });
    }

    return {
        info: {
            title: headerInfo?.nome_arquivo || headerInfo?.titulo || 'Relatório de insumos totalizados',
            author: headerInfo?.autor || '',
        },
        content: content,
        pageOrientation: 'landscape',
        footer: (currentPage: number, pageCount: number) => {
            const dataGeracao = dayjs().format("DD/MM/YYYY, HH:mm:ss");
            return {
                stack: [
                    { text: '', margin: [0, 5, 0, 0] },
                    {
                        canvas: [
                            {
                                type: 'rect',
                                x: 0,
                                y: 0,
                                w: 760,
                                h: 4,
                                linearGradient: ['#e5f1e1', '#5da57d', '#0e743f']
                            }
                        ],
                        margin: [0, 0, 0, 5]
                    },
                    { text: '', margin: [0, 5, 0, 0] },
                    {
                        columns: [
                            {
                                width: '*',
                                stack: [
                                    {
                                        image: 'imgLogoAlias',
                                        width: 50,
                                        margin: [0, 3, 0, 0],
                                    },
                                ],
                                alignment: 'left',
                            },
                            {
                                width: '*',
                                stack: [
                                    {
                                        text: `Gerado por: ${headerInfo?.autor}`,
                                        bold: true,
                                        alignment: 'center',
                                        fontSize: 7,
                                        color: '#4D4D4D'
                                    },
                                    {
                                        text: `${dataGeracao}`,
                                        alignment: 'center',
                                        fontSize: 7,
                                        color: '#4D4D4D'
                                    },
                                ],
                                margin: [0, 3, 0, 0],
                                alignment: 'center',
                            },
                            {
                                width: '*',
                                text: `${currentPage} de ${pageCount}`,
                                alignment: 'right',
                                fontSize: 8,
                                margin: [0, 3, 0, 0],
                                color: '#4D4D4D'
                            },
                        ],
                    },
                    {
                        width: '*',
                        text: headerInfo?.razaoSocial ?? '',
                        alignment: 'left',
                        fontSize: 6,
                        margin: [0, 3, 0, 10],
                        color: '#4D4D4D'
                    },
                ],
                margin: [40, 0, 40, 0],
            };
        },
        images: {
            imgLogoAlias: imgLogo
        },
        styles: {
            headerMain: {
                fontSize: 20,
                bold: true,
                color: 'black'
            },
            headerPropriedade: {
                fontSize: 14,
                bold: true
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: 'white',
                alignment: 'left'
            }
        },
        defaultStyle: {
            fontSize: 10,
            alignment: 'left'
        },
        pageMargins: [40, 40, 40, 60]
    };
};

export const gerarPdfDataUrl = async (
    dados: (typeEstruturaCompraInsumos | typeInsumos)[],
    headerInfo?: HeaderDef
): Promise<string> => {
    if (headerInfo?.logo && headerInfo.logo.startsWith("http")) {
        headerInfo.logo = await fetchImageAsBase64(headerInfo.logo);
    }

    return new Promise((resolve, reject) => {
        try {
            const docDefinition = gerarDocDefinition(dados, headerInfo);
            pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
                resolve(dataUrl);
            });
        } catch (err) {
            reject(err);
        }
    });
};

export const imprimirPdfCompraInsumos = async (
    dados: (typeEstruturaCompraInsumos | typeInsumos)[],
    headerInfo?: HeaderDef
): Promise<void> => {
    if (headerInfo?.logo && headerInfo.logo.startsWith("http")) {
        headerInfo.logo = await fetchImageAsBase64(headerInfo.logo);
    }

    const docDefinition = gerarDocDefinition(dados, headerInfo);

    return new Promise((resolve, reject) => {
        try {
            pdfMake.createPdf(docDefinition).getBlob((blob) => {
                const blobUrl = URL.createObjectURL(blob);

                // 1. Salva o título original da página
                const originalTitle = document.title;

                // 2. Define o título temporário (usado como nome do arquivo na janela de impressão/salvamento)
                const fileTitle = headerInfo?.nome_arquivo || headerInfo?.titulo || 'Relatório';
                const tempTitle = fileTitle.replace(/[/\\?%*:|"<>]/g, '-');
                document.title = tempTitle;

                // 3. Cria um iframe oculto na página
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.top = '0';
                iframe.style.left = '0';
                iframe.style.width = '1px';
                iframe.style.height = '1px';
                iframe.style.opacity = '0.01';
                iframe.style.pointerEvents = 'none';
                iframe.style.border = 'none';
                iframe.src = blobUrl;

                document.body.appendChild(iframe);

                let cleanedUp = false;
                const cleanUp = () => {
                    if (cleanedUp) return;
                    cleanedUp = true;

                    document.title = originalTitle;
                    URL.revokeObjectURL(blobUrl);
                    if (iframe.parentNode) {
                        document.body.removeChild(iframe);
                    }

                    // Remove ouvintes globais para evitar vazamento
                    window.removeEventListener('afterprint', cleanUp);
                    window.removeEventListener('focus', cleanUp);
                };

                // Ouvintes para restaurar o título original apenas quando o diálogo de impressão fechar
                window.addEventListener('afterprint', cleanUp);
                window.addEventListener('focus', cleanUp);

                iframe.onload = () => {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow?.focus();
                            iframe.contentWindow?.print();

                            // Resolve a Promise imediatamente após disparar a janela de impressão
                            resolve();
                        } catch (printErr) {
                            console.error("Erro ao invocar a impressão do iframe:", printErr);
                            cleanUp();
                            reject(printErr);
                        }
                    }, 500); // Pequeno atraso para garantir o carregamento do PDF no iframe
                };

                iframe.onerror = (err) => {
                    cleanUp();
                    reject(err);
                };
            });
        } catch (err) {
            reject(err);
        }
    });
};
